import { deviceType } from '@/utils/common'
import BlankLayout from '../layout/blankLayout.vue'
import OfferListPc from './pc/offerLetter/list.vue'
import DetailPc from './pc/offerLetter/detail.vue'
import OfferListMobile from './mobile/offerLetter/list.vue'
import DetailMobile from './mobile/offerLetter/detail.vue'

const basePath = '/recruiting/personal/offer-letter'

export default {
  name: 'offerLetterList',
  path: `${basePath}`,
  redirect: `${basePath}/list`,
  component: BlankLayout,
  meta: {
    titleI18nKey: 'personal.offerLetter.title.myOffer',
    isAllInclude: true,
    mobileHomeMenu: {
      iconClass: 'iconapplications',
      nameI18nKey: 'personal.offerLetter.title.myOffer',
      descI18nKey: 'personal.offerLetter.title.myOffer'
    }
  },
  children: [
    {
      path: `${basePath}/list`,
      component: deviceType.isPc ? OfferListPc : OfferListMobile,
      meta: {
        titleI18nKey: 'personal.offerLetter.title.myOffer',
        isAllInclude: true,
        mobileHomeMenu: {
          iconClass: 'iconapplications',
          nameI18nKey: 'personal.offerLetter.title.myOffer',
          descI18nKey: 'personal.offerLetter.title.myOffer'
        },
        rootLayout: {
          // hiddenBackgroundColor: true
        }
      }
    },
    {
      path: `${basePath}/:inviteId/detail`,
      component: deviceType.isPc ? DetailPc : DetailMobile,
      meta: {
        isInclude: true,
        titleI18nKey: 'personal.offerLetter.title.myOffer'
      }
    }
  ]
}
